import { Divider } from '@chakra-ui/react';
import React from 'react';

import DateMatter from '../../../../components/DateMatter';
import { BackButton } from '../../../../components/StyledButton';
import { useEngeneNavigate } from '../../../../hooks/navigate';
import { UserSummary } from '../../../../models/gen/userSummary';
import { WorkerAssignOutsourceMemberSearchResultData } from '../../../../models/gen/workerAssignOutsourceMemberSearchResultData';
import AssignForm from './assign-form/AssignForm';

/**
 *
 */
type WorkerAssignmentContentProps = {
  members?: UserSummary[];
  result?: WorkerAssignOutsourceMemberSearchResultData;
};

/**
 *
 * @returns
 */
const WorkerAssignmentContent: React.FunctionComponent<
  WorkerAssignmentContentProps
> = ({ members, result }) => {
  const navigate = useEngeneNavigate();

  return (
    <>
      <DateMatter
        customerName={result?.customerName}
        dateString={result?.date}
        matterId={result?.matterId}
        matterName={result?.matterName}
      />
      <Divider />
      <AssignForm members={members || []} state={result} />
      <BackButton onClick={() => navigate(-1)} />
    </>
  );
};

export default WorkerAssignmentContent;
